<h3>Regelmatige bestuurder wijzigen</h3>
<form *ngIf="form" [formGroup]="form">
    <wuc-form-field>
        <wuc-form-field-label [ngSwitch]="purchasedProduct?.productId">
            <ng-container *ngSwitchCase="productIdEnum.Car">Wie rijdt het meest in uw auto?</ng-container>
            <ng-container *ngSwitchCase="productIdEnum.Moped">Wie rijdt het meest op uw brommer?</ng-container>
            <ng-container *ngSwitchCase="productIdEnum.Motorcycle">
                Wie rijdt het meest op uw motor?
            </ng-container>
            <ng-container *ngSwitchDefault>Wie rijdt het meest?</ng-container>
        </wuc-form-field-label>
        <ng-container *ngIf="elements.length > 0; else loadingElement">
            <ng-container *ngFor="let element of elements">
                <wuc-input-radio
                    name="relationCode"
                    formControlName="relationCode"
                    id="driver-{{ element?.contentId}}"
                    [value]="element?.contentId"
                >
                    {{element?.contentDescription}}
                </wuc-input-radio>
            </ng-container>
        </ng-container>
        <ng-template #loadingElement>
            <wuc-skeleton width="150px" height="35px"></wuc-skeleton>
        </ng-template>
    </wuc-form-field>
</form>
<div
    *ngIf="isDeviantDriver && isVehicle"
    class="insurance-regular-driver-form-alert"
    [ngSwitch]="relationCode.value"
>
    <wuc-alert *ngSwitchCase="relationCodeEnum.Partner"
               icon="privacy"
               type="neutral"
               text="Let op: dit kan alleen als uw partner op hetzelfde adres woont en het voertuig op uw eigen naam staat!"></wuc-alert>

    <wuc-alert *ngSwitchCase="relationCodeEnum.Child"
               icon="privacy"
               type="neutral"
               text="Let op: dit kan alleen als het voertuig op uw eigen naam staat en niet op die van uw kind! Uw kind moet
                ook op hetzelfde adres als u wonen."></wuc-alert>
</div>
<ng-container
    *ngIf="[relationCodeEnum.Owner, relationCodeEnum.Partner, relationCodeEnum.Child].includes(relationCode.value)"
    [ngSwitch]="relationCode.value"
>
    <ng-container *ngSwitchDefault>
        <ins-insurance-policy-holder-form [purchasedProduct]="purchasedProduct"></ins-insurance-policy-holder-form>
    </ng-container>
    <ng-container *ngSwitchCase="relationCodeEnum.Partner">
        <ins-insurance-deviant-driver-form
            [purchasedProduct]="purchasedProduct"
            [relationCode]="relationCode.value"
        ></ins-insurance-deviant-driver-form>
    </ng-container>
    <ng-container *ngSwitchCase="relationCodeEnum.Child">
        <ins-insurance-deviant-driver-form
            [purchasedProduct]="purchasedProduct"
            [relationCode]="relationCode.value"
        ></ins-insurance-deviant-driver-form>
    </ng-container>
</ng-container>
